import React from 'react'

import T from 'components/FormattedMessage'

import { Grid, Typography, createStyles, withStyles, WithStyles, Theme } from '@material-ui/core'

import AutoSubCount from '../AutoSubCount'

interface Props {
  remainingSubs: number
  message: React.ReactNode
  rightChild: React.ReactNode
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: `${theme.spacing()}px ${theme.spacing() * 2}px`,
  },
  messageContainer: {
    marginRight: theme.spacing(),
    marginLeft: theme.spacing() * 2,
  },
  rightChildContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const AutoSubBase: React.SFC<InjectedProps> = ({ remainingSubs, rightChild, message, classes }) => (
  <div className={classes.root}>
    <Grid container direction="row" alignItems="center">
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <AutoSubCount value={remainingSubs} />
          </Grid>
          <Grid item>
            <Typography variant="caption">
              <T id="autosub_feature" />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs className={classes.messageContainer}>
        <Typography variant="body2">
          {message}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <div className={classes.rightChildContainer}>
          {rightChild}
        </div>
      </Grid>
    </Grid>
  </div>
)

export default withStyles(styles)(AutoSubBase)
